import { createStore } from 'vuex'
import axios from "axios";
//import router from '@/router'

export default createStore({
  state: {
    user: {},
  },
  getters: {
    getUser(state) {
      return state.user;
    },
  },
  mutations: {
    user(state, user) {
      state.user = user;
    },
    logIn(state, token) {
      localStorage.setItem('token', token);
      let data = new FormData();
      data.append('token', token);
      axios.post('/api.php?action=login', data)
          .then(function (response) {
              state.user = response.data;
              //router.push('/');
          })
          .catch(function () {
            //localStorage.removeItem('token');
          });
    },
    logOut(state) {
      localStorage.removeItem('token');
      state.user = {};
      //router.push('/');
      window.location = "/";
    }
  },
  actions: {
  },
  modules: {
  }
})
